import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import INFLEARN_IMAGE2 from './inflearn.jpg';

export const INFLEARN_IMAGE = INFLEARN_IMAGE2;
export const INFLEARN_LINK =
  'https://www.inflearn.com/course/%EC%8B%A4%EC%A0%84-%EB%A6%AC%EC%95%A1%ED%8A%B8-%ED%94%84%EB%A1%9C%EA%B7%B8%EB%9E%98%EB%B0%8D';
export const BLOG_LINK = 'https://medium.com/@ljs0705';
export const PORTING_BLOG_LINK =
  'https://medium.com/@ljs0705/%EC%B9%B4%EC%B9%B4%EC%98%A4%ED%8E%98%EC%9D%B4%EC%A7%80-%EC%9B%B9-react-%ED%8F%AC%ED%8C%85-%ED%9B%84%EA%B8%B0-76402cc5e031';
export const CHARGER_LINK =
  'http://item.gmarket.co.kr/DetailView/Item.asp?goodscode=1484030134&GoodsSale=Y&jaehuid=200001169&NaPm=ct%3Djvhetd7k%7Cci%3Dbd8e5b4a2becd9b208bc1306eb912dcc121dadb4%7Ctr%3Dslc%7Csn%3D24%7Chk%3D4376d3e717ad736367e9eb7d5aeeb33c427c5708  ';
export const ANI_TIME = 500;
export const BACKGROUND_COLOR = '#272731';
export const MAX_WIDTH = 600;
export const CONTAINER_PADDING = 20;
export const Ani = styled.span<{ show: boolean }>`
  opacity: ${props => (props.show ? 1 : 0)};
  transition: all ${ANI_TIME / 1000}s ease-in-out;
  font-weight: bold;
`;

export const QuizContainer = styled.div`
  position: absolute;
  width: 100%;
  padding: ${CONTAINER_PADDING}px;
  transition: all ${ANI_TIME / 1000}s ease-in-out;
  font-weight: bold;
`;

export const MODAL_ANIMATION_DURATION = 100;
export const GlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background-color: ${BACKGROUND_COLOR};
  overflow-x: hidden;
}

.ReactModal__Body--open {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.ReactModal__Overlay {
  opacity: 0;
  transition: opacity ${MODAL_ANIMATION_DURATION}ms ease-out;
}
.ReactModal__Overlay--after-open {
  opacity: 1;
}
.ReactModal__Overlay--before-close {
  opacity: 0;
}

.ReactModal__Content {
  opacity: 0;
  transform: scale(0.7);
  transition: all ${MODAL_ANIMATION_DURATION}ms ease-in;
}
.ReactModal__Content--after-open {
  opacity: 1;
  transform: scale(1);
}
.ReactModal__Content--before-close {
  opacity: 0;
  transform: scale(0.7);
}
`;

export enum ZIndex {
  Header = 10,
  Modal = 100,
}

// TODO: 모든 email 가져오기
// import * as firebase from 'firebase/app';
// import 'firebase/firestore';
// firebase.initializeApp({
//   apiKey: 'AIzaSyAqFjFNaHIkFnc4ihEMckBtoSziTUGOVjc',
//   authDomain: 'react-quiz-e5ba2.firebaseapp.com',
//   databaseURL: 'https://react-quiz-e5ba2.firebaseio.com',
//   projectId: 'react-quiz-e5ba2',
//   storageBucket: 'react-quiz-e5ba2.appspot.com',
//   messagingSenderId: '323295321801',
//   appId: '1:323295321801:web:f2368c6aa4c9ea5f',
// });
// firebase
//   .firestore()
//   .collection('email-list')
//   .get()
//   .then(function(querySnapshot) {
//     querySnapshot.forEach(function(doc) {
//       console.log(doc.data().email);
//     });
//   });
